const findTitle = (path: string) => {
    const ROUTES = [
        {
            title: 'IMDA IRIS Classification and Licensing Services',
            toPath: '/'
        },
        {
            title: 'Applications | IMDA IRIS Classification and Licensing Services',
            toPath: '/applications'
        },
        {
            title: 'Applications | IMDA IRIS Classification and Licensing Services',
            toPath: '/applications'
        },
        {
            title: 'Guides | IMDA IRIS Classification and Licensing Services',
            toPath: '/guides'
        },
        {
            title: 'Guides | IMDA IRIS Classification and Licensing Services',
            toPath: '/guide'
        },
        {
            title: 'Databases | IMDA IRIS Classification and Licensing Services',
            toPath: '/databases'
        },
        {
            title: 'Database | IMDA IRIS Classification and Licensing Services',
            toPath: '/databases'
        },
        {
            title: 'My Applications | IMDA IRIS Classification and Licensing Services',
            toPath: '/my-applications'
        },
        {
            title: 'My Applications | IMDA IRIS Classification and Licensing Services',
            toPath: '/my-applications'
        },
        {
            title: 'Login | IMDA IRIS Classification and Licensing Services',
            toPath: '/login'
        }
    ];
    return ROUTES?.find(({ toPath }) => toPath === path) ?? { title: 'IMDA IRIS Classification and Licensing Services', toPath: '/' };
};

export default findTitle;
